import { ITooltipSchema } from '../../repositories/price-estimator/entities/onboardings/TooltipSchema';
import { IApplicationState } from '../../types/redux';

export const selectOnbordingData = (state: IApplicationState): ITooltipSchema[] => state.onbording.data;
